module.exports = __webpack_public_path__ + "static/media/pdam.c9e7cb50.png";